<h1 mat-dialog-title>Superusers organisaties beheren</h1>

<div mat-dialog-content class="dialog-no-overflow">
  <form [formGroup]="superUserForm" autocomplete="off">
    <mat-form-field>
      <mat-label>Superuser</mat-label>
      <mat-select formControlName="user">
        @for (user of superUsers(); track user.id) {
          <mat-option [value]="user">
            {{ user.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @for (org of orgs(); track org.id) {
      <mat-checkbox matInput (change)="orgChecked($event, org)" formControlName="{{ org.id }}" [checked]="org.checked">
        {{ org.name }}
      </mat-checkbox>
    }
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>

  <button mat-flat-button (click)="save()">Opslaan</button>
</div>
